var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "loading-bar",
      },
      [
        _c("div", {
          staticClass: "loading-bar__bar",
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }